export default __webpack_public_path__ + "assets/favicons/favicon-alert.ico";